import {
  PAGE_ID_CLASSIFY,
  PAGE_ID_WRITE,
  PAGE_ID_PAY_AND_POST_V2,
  PAGE_ID_SELECT_AD_TYPE,
} from 'src/app/shared/constants/pageUid';
import type { Cart, DraftJob } from 'src/graphql/generated';

import {
  isClassifyPageCompleted,
  isSelectAdPageCompleted,
  isWritePageCompleted,
} from './isPageComplete';

export const getLastValidPage = (draftJob?: DraftJob, cart?: Cart) => {
  if (!isClassifyPageCompleted(draftJob)) {
    return PAGE_ID_CLASSIFY;
  }

  if (!isSelectAdPageCompleted(cart)) {
    return PAGE_ID_SELECT_AD_TYPE;
  }

  if (!isWritePageCompleted(draftJob)) {
    return PAGE_ID_WRITE;
  }

  return PAGE_ID_PAY_AND_POST_V2;
};
